import jsLogic from 'json-logic-js'
import {getConfig} from '../configs/game-config-provider.js'
import {disableAd, initBannerAd} from '../ad-manager.js'
import {CxfEvents, AdBannerEvent} from '../constants.js'
import log from '../utils/logger.js'
import {getGameController} from './game-provider.js'

let cxf
let gameController
let adConfig

const validate = (loginData, rules) => jsLogic.apply(rules, loginData)

const updatePayHandler = (payload) => {
    console.log(`UpdatePay handler ${payload}`)

    if (!validate(payload, adConfig.rules.paymentData)) {
        disableAd()
    }
}

const CUSTOM_HANDLERS_MAP = new Map([
    [AdBannerEvent.UPDATE_PAY, updatePayHandler]
])

const init = (context) => {
    cxf = context
    gameController = getGameController(cxf)
    adConfig = getConfig(cxf)

    console.log(gameController)
    registerHandlers()
}

const addLoginHandler = () => {
    cxf.on(CxfEvents.Login, (loginData) => {
        log.debug('Login handler has been triggered!')

        if (validate(loginData, adConfig.rules.loginData)) {
            initBannerAd(adConfig)
        } else {
            log.info(`The banner is not comply the rules`, loginData)
            disableAd()
        }
    })
}

const gameEventTrigger = (eventName, payload) => {
    log.debug(`triggerCallback - [${eventName}, ${payload}]`)
    if (!CUSTOM_HANDLERS_MAP.has(eventName)) {
        log.warn(`Event ${eventName} is not registered in handlers map`)
    }

    const callback = CUSTOM_HANDLERS_MAP.get(eventName)
    callback(payload)
}

const registerHandlers = () => {
    addLoginHandler()

    gameController.registerCustomGameHandlers(cxf, gameEventTrigger)
}

export {init}
